import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { ErrorState } from '@repo/design-system-kit/components/error-state/error-state';
import { CFT } from '@repo/shared-kit/sentry/sentry-tags';
import { useSentry } from '@repo/shared-kit/sentry/context';

interface KycErrorProps {
  onRetry: () => void;
}

export function KycError({ onRetry }: KycErrorProps) {
  const { formatMessage } = useIntl();
  const sentry = useSentry();

  useEffect(() => {
    sentry.captureMessage('KYC error screen displayed', {
      level: 'warning',
      tags: { component: 'KycError' },
      cft: CFT.IDENTITY_VERIFICATION,
    });
  }, [sentry]);

  return (
    <ErrorState
      onRetry={onRetry}
      retryButtonText={formatMessage({ defaultMessage: 'Try again', id: 'generic.try-again.cta' })}
      retryButtonVariant="primary"
      subtitle={formatMessage({
        defaultMessage: "We couldn't proceed with your request. Can you try again?",
        id: 'identity-verification-kit.kyc.error.subtitle',
      })}
      title={formatMessage({
        defaultMessage: 'An error occurred',
        id: 'identity-verification-kit.kyc.error.title',
      })}
    />
  );
}
